import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { loginWith } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      loginWith(data.token, data.user);
      toast.success("Access granted");
      navigate(data.user.role === "admin" ? "/admin" : data.user.role === "support" ? "/support/admin" : "/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="w-full max-w-md fadeup">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/ai-logo.jpg" alt="AI ID Card" className="h-28 w-auto object-contain logo-neon" />
        </Link>

        <div className="border border-zinc-800 bg-[#090A0C] p-8">
          <p className="font-mono-p text-xs tracking-[0.3em] uppercase text-cyan-400 mb-2">
            // Authentication
          </p>
          <h1 className="font-mono-p font-bold uppercase tracking-tight text-2xl mb-8">
            Login
          </h1>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="font-mono-p text-xs uppercase tracking-widest text-zinc-500">
                Email
              </label>
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full bg-black border border-zinc-800 px-4 py-3 text-zinc-100 text-sm focus:border-cyan-400/60 focus:outline-none focus:ring-1 focus:ring-cyan-400/30 transition-colors"
              />
            </div>
            <div>
              <label className="font-mono-p text-xs uppercase tracking-widest text-zinc-500">
                Password
              </label>
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full bg-black border border-zinc-800 px-4 py-3 text-zinc-100 text-sm focus:border-cyan-400/60 focus:outline-none focus:ring-1 focus:ring-cyan-400/30 transition-colors"
              />
            </div>
            <button
              data-testid="login-submit"
              disabled={loading}
              className="w-full font-mono-p text-sm uppercase tracking-widest bg-cyan-400 text-black py-3.5 font-bold hover:bg-cyan-300 transition-colors disabled:opacity-50"
            >
              {loading ? "Verifying..." : "Enter Protocol"}
            </button>
          </form>
        </div>

        <p className="text-center mt-6 text-sm text-zinc-500">
          Have a key?{" "}
          <Link to="/register" data-testid="login-to-register" className="text-cyan-400 hover:underline">
            Activate it
          </Link>
        </p>
      </div>
    </div>
  );
}
